module.exports = __webpack_public_path__ + "img/hp.5d08b35c.svg";